
import { Options, Vue } from "vue-class-component";
import SearchForm from "@/components/SearchForm.vue";
import { inject } from "@vue/runtime-core";
import {
  RequestStatus,
  VouchersService,
  VOUCHER_SERVICE,
} from "@/services/vouchers-service";

@Options({
  components: {
    SearchForm,
  },
})
export default class SearchVouchersView extends Vue {
  show = true;
  private voucherService!: VouchersService;
  private nextRoute!: string;
  private transitionLeaved = false;

  beforeCreate(): void {
    const voucherService = inject<VouchersService>(VOUCHER_SERVICE);

    if (!voucherService) {
      console.error("No voucher service injected");
      this.$router.push({ name: "error" });
    }

    this.voucherService = voucherService as VouchersService;
  }

  afterTransition(): void {
    this.pushRoute(null);
  }

  onPay(event: string): void {
    this.show = false;
    this.voucherService
      .getVouchers(event)
      .then((status: RequestStatus) => {
        switch (status) {
          case RequestStatus.OK:
            this.pushRoute("vouchers");
            break;
          case RequestStatus.NO_VOUCHERS:
            this.pushRoute("up-to-date");
            break;
          case RequestStatus.NO_CREDITOR:
            this.pushRoute("creditor-not-found");
            break;
        }
      })
      .catch(() => {
        this.pushRoute("error");
      });
  }

  private pushRoute(route: string | null) {
    if (route) {
      this.nextRoute = route;
    } else {
      this.transitionLeaved = true;
    }
    if (this.nextRoute && this.transitionLeaved) {
      this.$router.push(this.nextRoute);
    }
  }
}
